/* const GilroyFontThinUrls: FontFileStyleType = Object.freeze({
  normal: {
    woff2: 'https://cdn140.picsart.com/66639402799341365665.woff2',
  },
  italic: {
    woff2: 'https://cdn140.picsart.com/49126424799030180537.woff2',
  },
}); */
/* const GilroyFontExtraLightUrls: FontFileStyleType = {
  normal: {
    woff2: 'https://cdn140.picsart.com/39345958867651457730.woff2',
  },
  italic: {
    woff2: 'https://cdn140.picsart.com/64323524026727032265.woff2',
  },
}; */
/* const GilroyFontLightUrls: FontFileStyleType = {
  normal: {
    woff2: 'https://cdn140.picsart.com/70508065077428789025.woff2',
  },
  italic: {
    woff2: 'https://cdn140.picsart.com/78466976049360945564.woff2',
  },
}; */
const GilroyFontRegularUrls = {
    normal: {
        woff2: 'https://pastatic.picsart.com/cms-pastatic/d018cb40-40a8-4efa-a202-947285ae8329.woff2',
    },
    italic: {
        woff2: 'https://pastatic.picsart.com/cms-pastatic/777f5347-1aaf-49bd-8399-223ffe39d52f.woff2',
    },
};
const GilroyFontMediumUrls = {
    normal: {
        woff2: 'https://pastatic.picsart.com/cms-pastatic/3de40576-a960-483a-a3ab-a1743e3c4ba6.woff2',
    },
    italic: {
        woff2: 'https://pastatic.picsart.com/cms-pastatic/29638842-7b80-41e7-8010-2f70c069f1e9.woff2',
    },
};
const GilroyFontSemiBoldUrls = {
    normal: {
        woff2: 'https://pastatic.picsart.com/cms-pastatic/eae6e1ea-9319-406c-a3de-00431f8f03f4.woff2',
    },
    italic: {
        woff2: 'https://pastatic.picsart.com/cms-pastatic/1926d8ab-bb9b-4c73-bac5-2036808e22c7.woff2',
    },
};
const GilroyFontBoldUrls = {
    normal: {
        woff2: 'https://pastatic.picsart.com/cms-pastatic/0ea441d6-d0d4-4236-b649-67a987887865.woff2',
    },
    italic: {
        woff2: 'https://pastatic.picsart.com/cms-pastatic/ed196cf9-6e01-4333-8370-ef8544c92acc.woff2',
    },
};

export { GilroyFontBoldUrls, GilroyFontMediumUrls, GilroyFontRegularUrls, GilroyFontSemiBoldUrls };
